<template>
    <v-dialog
        id="toto"
        class="dialog-disclaimer"
        v-model="isDisplayed"
        persistent
    >
        <CookieCard
            class="dialog-disclaimer"
            @accept-policies="acceptPolicies"
            @reject-policies="rejectPolicies"
            @save-custom-settings="saveSettings"
        />
    </v-dialog>
</template>

<script>
    import CookieCard from '@/components/gdpr/CookieCard';

    export default {
        name: 'CookieDialog',
        components: {
            CookieCard
        },
        props: {
            isDisplayed: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            acceptPolicies() {
                this.$emit('accept-policies');
            },
            rejectPolicies() {
                this.$emit('reject-policies');
            },
            saveSettings() {
                this.$emit('save-custom-settings')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gdpr/CookieDialog.vue